<template>
    <div>
        <div :class="headingClasses">Subscriptions</div>
        <div :class="gridClasses">
            <div :class="gridKeyClasses">
                Marketing:
            </div>
            <div :class="gridValueClasses">
                <vx-icon-loading v-if="loadingSubscriptions"
                    spin></vx-icon-loading>
                <contact-subscription-badge v-else
                    type="marketing"
                    :status="marketingStatus"></contact-subscription-badge>
            </div>
            <div :class="gridKeyClasses">
                Transactional:
            </div>
            <div :class="gridValueClasses">
                <vx-icon-loading v-if="loadingSubscriptions"
                    spin></vx-icon-loading>
                <contact-subscription-badge v-else
                    type="transactional"
                    :status="transactionalStatus"></contact-subscription-badge>
            </div>
        </div>
        <div :class="headingClasses">Tags</div>
        <div class="vx-mb-6">
            <vx-icon-loading v-if="loadingTags"
                spin></vx-icon-loading>
            <vx-alert :closeable="false"
                v-else-if="!tags.length">No tags were added to this contact.</vx-alert>
            <vx-disclosure v-else
                appearance="boxed"
                v-model:active="tagsDisclosure">
                <template v-slot:header>
                    <font-awesome-icon class="vx-text-slate-300"
                        :icon="faTag"
                        fixed-width></font-awesome-icon>
                    <span>{{ tags.length }}</span>
                </template>
                <template v-slot:content>
                    <div class="vx-flex vx-flex-wrap vx-gap-2">
                        <div v-for="tag in tags"
                            :key="tag"
                            class="vx-py-0.5 vx-px-2 vx-bg-slate-100 vx-break-all vx-rounded-[4px] vx-flex vx-items-center vx-text-slate-500 vx-text-xs">
                            {{ tag }}
                        </div>
                    </div>
                </template>
            </vx-disclosure>
        </div>
        <template v-if="FEATURES.contact_groups && !groupId">
            <div :class="headingClasses">Groups</div>
            <div class="vx-mb-6">
                <vx-icon-loading v-if="loadingGroups"
                    spin></vx-icon-loading>
                <vx-alert :closeable="false"
                    v-else-if="!groups.length">No groups were specified for this contact.</vx-alert>
                <vx-disclosure v-else
                    appearance="boxed"
                    v-model:active="groupsDisclosure">
                    <template v-slot:header>
                        <font-awesome-icon class="vx-text-slate-300"
                            :icon="faGrid2Plus"
                            fixed-width></font-awesome-icon>
                        <span>{{ groups.length }}</span>
                    </template>
                    <template v-slot:content>
                        <div class="vx-flex vx-flex-wrap vx-gap-2">
                            <div v-for="group in groups"
                                :key="group.group_id"
                                class="vx-py-0.5 vx-px-2 vx-bg-slate-100 vx-break-all vx-rounded-[4px] vx-flex vx-items-center vx-text-slate-500 vx-text-xs">
                                {{ group.group_id }}
                            </div>
                        </div>
                    </template>
                </vx-disclosure>
            </div>
        </template>
        <div :class="headingClasses">Custom Attributes</div>
        <vx-icon-loading spin
            v-if="loadingCustomAttributes"></vx-icon-loading>
        <vx-alert :closeable="false"
            v-else-if="!customAttributes.length"
            class="vx-text-sm">No custom attributes were added to
            this contact.</vx-alert>
        <div :class="gridClasses">
            <template v-for="customAttribute in customAttributes"
                :key="customAttribute.key">
                <div :class="gridKeyClasses">
                    {{ customAttribute.key }}:
                </div>
                <div :class="gridValueClasses">
                    {{ customAttribute.value }}
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
import { faGrid2Plus, faTag } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxAlert,
    VxDisclosure,
    VxIconLoading
} from "@voxie/frontend-components";
import { inject, ref, watch } from 'vue';
import ContactSubscriptionBadge from '../ContactSubscriptionBadge.vue';
import { useContactDetails } from '../useContactDetails';

const FEATURES = inject('FEATURES')

const tagsDisclosure = ref(false);
const groupsDisclosure = ref(false);

const headingClasses = 'vx-font-semibold vx-text-base vx-mb-2 vx-flex vx-items-center vx-justify-between'
const gridClasses = 'vx-grid vx-grid-cols-12 vx-items-center vx-gap-y-2 vx-gap-x-1 vx-text-slate-800 vx-text-sm vx-mb-6 last-of-type:vx-mb-0';
const gridKeyClasses = 'vx-col-span-3 vx-break-all vx-text-xs vx-text-slate-500';
const gridValueClasses = 'vx-col-span-9 vx-break-all';

const {
    groupId,

    loadingGroups,
    groups,

    marketingStatus,
    transactionalStatus,
    loadingSubscriptions,

    loadingTags,
    tags,

    loadingCustomAttributes,
    customAttributes,
} = useContactDetails();

watch([
    () => groups.value.length,
    () => tags.value.length,
], () => {
    groupsDisclosure.value = groups.value.length <= 25;
    tagsDisclosure.value = tags.value.length <= 25;
});

</script>
